import React from 'react'

export default function GameEvents({events}) {
  return <table className='table table-striped'>
    <thead>
      <tr>
        <th>Time</th>
        <th>User</th>
        <th>Activity</th>
      </tr>
    </thead>
    <tbody>
      { 
        events.map((event, index) => {
          return <tr key={index}>
            <td>{event.date}</td>
            <td>{event.user}</td>
            <td>{event.description}</td>
          </tr>
        })
      }
    </tbody>
  </table>
}
